export default {
  'Alinhadores Ortodontia Digital': 'Alinhadores Ortodontia Digital',
  'Distúrbios respiratórios e a Ortodontia':
    'Distúrbios respiratórios e a Ortodontia',
  Expediente: 'Expediente',
  'Soluções e protocolos clínicos': 'Soluções e protocolos clínicos',
  'Editorial Inovação': 'Editorial Inovação',
  'Opinião de Especialista': 'Opinião de Especialista',
  Abstracts: 'Abstracts',
  'Clinical Approach': 'Clinical Approach',
  'Artigo Clínico': 'Artigo Clínico',
  'Artigo de Divulgação': 'Artigo de Divulgação',
  'Artigo Inédito': 'Artigo Inédito',
  'Artigo Original': 'Artigo Original',
  'Artigo de Pesquisa': 'Artigo de Pesquisa',
  'Arquitetura do Ambiente Clínico': 'Arquitetura do Ambiente Clínico',
  'Artigo Selecionado': 'Artigo Selecionado',
  Artigo: 'Artigo',
  'Artigo Selecionado BBO': 'Artigo Selecionado BBO',
  'Eu Penso Assim': 'Eu Penso Assim',
  'Atualização Profissional': 'Atualização Profissional',
  'Artigo Traduzido': 'Artigo Traduzido',
  'Caso Clínico BBO': 'Caso Clínico BBO',
  'Biologia da Estética': 'Biologia da Estética',
  'Boas ações despertam sorrisos': 'Boas ações despertam sorrisos',
  'Crônica Científica': 'Crônica Científica',
  'Caso Clínico': 'Caso Clínico',
  'Cantinho do Clínico': 'Cantinho do Clínico',
  'Comentários do Leitor': 'Comentários do Leitor',
  'Combatendo modismo com ciência': 'Combatendo modismo com ciência',
  'Controvérsias na Ortodontia': 'Controvérsias na Ortodontia',
  Cartas: 'Cartas',
  'Carta do Presidente': 'Carta do Presidente',
  'Caso Selecionado': 'Caso Selecionado',
  'Dental Architecture': 'Dental Architecture',
  'Dica Clínica': 'Dica Clínica',
  'Descrição de Caso': 'Descrição de Caso',
  'Dicas do Marden': 'Dicas do Marden',
  Dentino: 'Dentino',
  Diagnóstico: 'Diagnóstico',
  'Divulgação do colégio': 'Divulgação do colégio',
  'Diarios da Oclusão': 'Diarios da Oclusão',
  'Domínio Conexo': 'Domínio Conexo',
  'Dr. Playbo': 'Dr. Playbo',
  'DTM e dor orofacial': 'DTM e dor orofacial',
  'Explicações e Aplicações': 'Explicações e Aplicações',
  'Editorial BBO': 'Editorial BBO',
  'Editorial convidado': 'Editorial convidado',
  Editorial: 'Editorial',
  'Encontros educacionais: conhecimento em pauta':
    'Encontros educacionais: conhecimento em pauta',
  Empreendedorismo: 'Empreendedorismo',
  'Endo in Endo': 'Endo in Endo',
  Entrevista: 'Entrevista',
  'Estética em Ortodontia': 'Estética em Ortodontia',
  InDireta: 'InDireta',
  'Europério Abstract': 'Europério Abstract',
  'Expertise Clínica': 'Expertise Clínica',
  'Fot-ativação': 'Fot-ativação',
  'Fato ou Fake': 'Fato ou Fake',
  Fórum: 'Fórum',
  Fotografia: 'Fotografia',
  'Gestão em Odontologia': 'Gestão em Odontologia',
  Highlights: 'Highlights',
  'História da Ortodontia': 'História da Ortodontia',
  Homenagem: 'Homenagem',
  "Don't Believe the Hype": "Don't Believe the Hype",
  'Imagens na Ortodontia': 'Imagens na Ortodontia',
  'Instagram Nu e Cru': 'Instagram Nu e Cru',
  Inovações: 'Inovações',
  'Insight Ortodôntico': 'Insight Ortodôntico',
  Interview: 'Interview',
  'Recursos em Ortodontia': 'Recursos em Ortodontia',
  'Técnica Laboratorial': 'Técnica Laboratorial',
  Biomecânica: 'Biomecânica',
  'In Memorian': 'In Memorian',
  'Nota Científica dos Editores': 'Nota Científica dos Editores',
  'Navegando e Aprendendo': 'Navegando e Aprendendo',
  'Novidades Editoriais': 'Novidades Editoriais',
  'Nosso Planejamento Estratégico em Ação':
    'Nosso Planejamento Estratégico em Ação',
  'Nota Prévia': 'Nota Prévia',
  'Ortodontia Baseada em Evidência': 'Ortodontia Baseada em Evidência',
  'Ortodontia Objetiva': 'Ortodontia Objetiva',
  Observatório: 'Observatório',
  'Ortodontia Forense': 'Ortodontia Forense',
  'Orthodontics Highlights': 'Orthodontics Highlights',
  'Artigo Online': 'Artigo Online',
  Opinião: 'Opinião',
  'O que Há de Novo na Odontologia': 'O que Há de Novo na Odontologia',
  'Protocolo Clínico': 'Protocolo Clínico',
  'Ponto e Contraponto': 'Ponto e Contraponto',
  'Porque eu uso': 'Porque eu uso',
  'Pergunte a um Expert': 'Pergunte a um Expert',
  'Ponto de Vista': 'Ponto de Vista',
  'Pesquisa Clínica': 'Pesquisa Clínica',
  Prótese: 'Prótese',
  'Revisão de Literatura': 'Revisão de Literatura',
  'Artigo de Revisão': 'Artigo de Revisão',
  'Relato de Caso': 'Relato de Caso',
  'Sobre Dentes e Implantes': 'Sobre Dentes e Implantes',
  Snapshot: 'Snapshot',
  'Sua Clínica': 'Sua Clínica',
  'Test Drive Estética': 'Test Drive Estética',
  'Tópico Especial': 'Tópico Especial',
}
